

























































































import {Vue, Component, Watch} from 'vue-property-decorator'
import Tab1 from "@/views/Vozila/DetaljiVozila/Tab1.vue";
import Tab2 from "@/views/Vozila/DetaljiVozila/Tab2.vue";
import Tab5 from "@/views/Vozila/DetaljiVozila/Tab5.vue";
import Tab4 from "@/views/Vozila/DetaljiVozila/Tab4.vue";
import Tab3 from "@/views/Vozila/DetaljiVozila/Tab3.vue";
import Tab6 from "@/views/Vozila/DetaljiVozila/Tab6.vue";
import {TabBase} from "@/views/Vozila/DetaljiVozila/TabBase.ts";
import dataProxy from '@/services/data-proxy.service'

@Component({components: {Tab1, Tab2, Tab3, Tab4, Tab5, Tab6}})
export default class DetaljiVozila extends TabBase {

    trosakGoriva = 0;
    trosakServisa = 0;
    stanjeKilometraze = 0;

    get ukupno() {
        return this.trosakGoriva + this.trosakServisa;
    }

    async created() {
        await super.load();
        this.ucitajZaglavlje();
    }

    @Watch('$route') async onRouteChange() {
        await super.load();
        this.ucitajZaglavlje();
    }

    otvoriDetalje(id) {
        this.$router.push('/podaci-vozila/' + id);
    }

    async ucitajZaglavlje() {
        const zaglavlje = await this.loadData(() => dataProxy.vratiZaglavljePregledaVozila(this.vozilo.id))();
        this.trosakGoriva = zaglavlje.troskoviGoriva;
        this.trosakServisa = zaglavlje.troskoviOdrzavanja;
        this.stanjeKilometraze = zaglavlje.kilometraza;
    }

}
